import { useSyncExternalStore } from "react";

/** Where the browser remembers a collapsed sidebar (owner, 2026-10-21). */
export const SIDEBAR_COLLAPSED_KEY = "polaris.sidebar.collapsed";

/** Above the phone layout of global.css (64rem): there the sidebar is the side menu. */
const DESKTOP_QUERY = "(min-width: 64.0625rem)";

const subscribeDesktop = (onChange: () => void) => {
  const query = window.matchMedia(DESKTOP_QUERY);
  query.addEventListener("change", onChange);
  return () => query.removeEventListener("change", onChange);
};

/** Whether the screen shows the sidebar beside the page, where it can collapse. */
export function useDesktopSidebar(): boolean {
  return useSyncExternalStore(
    subscribeDesktop,
    () => window.matchMedia(DESKTOP_QUERY).matches,
    () => true,
  );
}

type SidebarStorage = Pick<Storage, "getItem" | "setItem">;

const browserStorage = (): SidebarStorage | null => {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
};

/** Collapsed only if this browser said so: a private window opens it expanded. */
export function readSidebarCollapsed(storage = browserStorage()): boolean {
  try {
    return storage?.getItem(SIDEBAR_COLLAPSED_KEY) === "1";
  } catch {
    return false;
  }
}

export function saveSidebarCollapsed(collapsed: boolean, storage = browserStorage()): void {
  try {
    storage?.setItem(SIDEBAR_COLLAPSED_KEY, collapsed ? "1" : "0");
  } catch {
    // Storage full or blocked: the choice lasts until the page reloads.
  }
}
